exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.end-padding[data-v-1f9b0126] {\n  padding-bottom: 84px;\n}\n", ""]);

// exports
